module.exports = __webpack_public_path__ + "img/back2Top.3e693d8.png";